export default "__VITE_ASSET__BmJeowml__"